var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("This short procedure verifies that your display and anaglyph glasses are configured correctly.")])
}
var staticRenderFns = []

export { render, staticRenderFns }